(function () {
  "use strict";
  var SCOPE = ".related-products-custom";

  /* WH-172: bounded/retrying fetch with plain-fetch fallback; cart POSTs are
     duplicate-safe via cartMutate. */
  var ehFetch = function (url, opts) {
    return window.EH && window.EH.fetchRetry ? window.EH.fetchRetry(url, opts) : fetch(url, opts);
  };
  var ehCartPost = function (url, payload) {
    return window.EH && window.EH.cartMutate
      ? window.EH.cartMutate(url, payload)
      : fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
  };

  /* ── Scrollbar (scoped, safe for async injection) ── */
  function initScrollbar(track) {
    try {
      if (!track || track.dataset.scrollbarBound) return;
      var wrap = track.closest(SCOPE);
      var thumb = wrap ? wrap.querySelector(".products-recommended__scrollbar-thumb") : null;
      if (!thumb) return;
      track.dataset.scrollbarBound = "1";
      function updateThumb() {
        var scrollable = track.scrollWidth - track.clientWidth;
        if (scrollable <= 0) { thumb.style.left = "0px"; return; }
        var ratio = track.scrollLeft / scrollable;
        var thumbMax = thumb.parentElement.clientWidth - thumb.offsetWidth;
        thumb.style.left = ratio * thumbMax + "px";
      }
      track.addEventListener("scroll", updateThumb, { passive: true });
      updateThumb();
    } catch (e) {}
  }

  function initAll() {
    try {
      document.querySelectorAll(SCOPE + " .products-recommended__track").forEach(initScrollbar);
    } catch (e) {}
  }

  /* ── Cart helpers ── */
  function getDrawerSectionId() {
    var el = document.querySelector("cart-drawer");
    if (!el) return null;
    var s = el.closest(".shopify-section");
    return s ? s.id.replace("shopify-section-", "") : null;
  }
  function dispatchCartOpen(cart) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true, detail: { baseEvent: "variant:add", cart: cart }
    }));
  }
  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var sectionId = getDrawerSectionId();
    var body = { id: variantId, quantity: 1 };
    if (sectionId) body.sections = sectionId;
    ehCartPost("/cart/add.js", body)
      .then(function (r) { return r.json(); })
      .then(function (addResp) {
        return ehFetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (addResp.sections) cart.sections = addResp.sections; return cart; });
      })
      .then(function (cart) {
        dispatchCartOpen(cart);
        var card = btn.closest(".product-card");
        var title = card ? ((card.querySelector(".product-card__name") || {}).textContent || "").trim() : "";
        var priceEl = card ? card.querySelector(".price-current") : null;
        var priceVal = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, "")) || 0 : 0;
        if (window.gtag) gtag("event", "add_to_cart", { currency: "INR", value: priceVal, items: [{ item_id: variantId, item_name: title, price: priceVal, quantity: 1 }] });
        if (window.fbq) fbq("track", "AddToCart", { content_ids: [variantId], content_type: "product", value: priceVal, currency: "INR" });
      })
      .catch(function (e) {});
  }

  /* ── Delegated click, but ONLY for cards inside this section ── */
  document.addEventListener("click", function (e) {
    try {
      var btn = e.target.closest && e.target.closest(".btn-card-cart");
      if (!btn || !btn.closest(SCOPE)) return;
      addToCart(btn);
    } catch (err) {}
  });

  /* ── Init + re-init when Discovery swaps cards in ── */
  function boot() {
    initAll();
    try {
      var obs = new MutationObserver(function () { initAll(); });
      document.querySelectorAll(".related-products-custom-rec").forEach(function (el) {
        obs.observe(el, { childList: true, subtree: true });
      });
    } catch (e) {}
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();

/* WH (staging): collapse recommended rail to 2 rows on mobile + "View all" toggle.
   Re-checks on timers + window load because the related rail loads its cards async. */
(function () {
  function setupWrap(wrap) {
    if (wrap.dataset.viewallInit) return;
    var track = wrap.querySelector(".products-recommended__track");
    if (!track) return;
    var cards = track.querySelectorAll(".product-card");
    if (cards.length <= 4) return; // not loaded yet, or genuinely few
    wrap.dataset.viewallInit = "1";
    wrap.classList.add("is-collapsed");
    var btn = document.createElement("button");
    btn.className = "products-recommended__viewall";
    btn.type = "button";
    btn.textContent = "View all";
    track.insertAdjacentElement("afterend", btn);
    btn.addEventListener("click", function () {
      wrap.classList.remove("is-collapsed");
      btn.remove();
    });
  }
  function initViewAll() {
    if (!(window.matchMedia && window.matchMedia("(max-width: 699px)").matches)) return;
    document.querySelectorAll(".products-recommended-wrap").forEach(setupWrap);
  }
  if (document.readyState !== "loading") initViewAll();
  else document.addEventListener("DOMContentLoaded", initViewAll);
  window.addEventListener("load", initViewAll);
  [600, 1500, 3000].forEach(function (t) { setTimeout(initViewAll, t); });
})();
